import store from '@/store';

/**
 * Gets the current patient ID from the store
 * @returns {string} The current patient ID or 'patient_001' as fallback
 */
export const getCurrentPatientId = () => {
  return store.state.patients?.currentPatientId;
};

export const fakeOrderStatusMessage = {
  "_id": "WNpT6Je8GZs3SHbSX",
  "t": "order_card",
  "rid": "68acac5dbc9247ee9040ec37",
  "attachments": [
      {
          "text": "This event is triggered when the order status is updated",
          "title": "new_order",
          "fields": [
              {
                  "title": "orderStatus",
                  "value": "new_order"
              },
              {
                  "title": "sampleId",
                  "value": "1003881"
              },
              {
                  "title": "julienBarcode",
                  "value": "9909096019"
              },
              {
                  "title": "patientId",
                  "value": "2000058"
              },
              {
                  "title": "customerId",
                  "value": "999997"
              },
              {
                  "title": "orderConfirmationNumber",
                  "value": ""
              },
              {
                  "title": "sampleOrderTime",
                  "value": "2025-09-09 21:18:46"
              },
              {
                  "title": "clinicId",
                  "value": "10136"
              },
              {
                  "title": "amount",
                  "value": "520"
              },
              {
                  "title": "source",
                  "value": "BillingSpring"
              },
              {
                  "title": "chargeMethod",
                  "value": "customerPay"
              },
              {
                  "title": "is_patient_has_address",
                  "value": "false"
              },
              {
                  "title": "orderId",
                  "value": "70139923542721062"
              },
              {
                  "title": "email_address",
                  "value": "\n\u0019sherrywork12345@gmail.com"
              },
              {
                  "title": "order_tags",
                  "value": ""
              },
              {
                  "title": "markup",
                  "value": "0.00"
              }
          ]
      }
  ],
  "ts": "2025-09-09T21:19:05.867Z",
  "u": {
      "_id": "oafKicny6TymdzNxQ",
      "username": "vrc",
      "name": "vrc"
  },
  "msg": "",
  "_updatedAt": "2025-09-09T21:19:05.911Z",
  "urls": [],
  "mentions": [],
  "channels": []
}